import React from "react";
import ExpenseForm from "../ExpenseForm";
import { Link } from "react-router-dom";
const Purchase = () => {
  const formDetails = [
    {
      label: "Supplier Name",
      id: "name",
      name: "customerName",
      type: "text",
    },
    {
      label: "Ph No ",
      id: "phone",
      name: "phone",
      type: "text",
    },
    {
      label: "Pan No",
      id: "panNo",
      name: "panNo",
      type: "text",
    },
    {
      label: "Bill No",
      id: "billNo",
      name: "billNo",
      type: "text",
    },
    {
      label: "Address",
      id: "address",
      name: "address",
      type: "text",
    },
    {
      label: "Date",
      id: "exportDate",
      name: "exportDate",
      type: "date",
    },
  ];
  const optionItems = [
    {
      optionOne: "Item",
      value: "",
    },
    {
      optionOne: "Item 1",
      value: "One",
    },
    {
      optionOne: "Item 2",
      value: "Two",
    },
    {
      optionOne: "Item 3",
      value: "Three",
    },
  ];

  const addDetails = [
    {
      label: "Items",
      name: "items",
      type: "select",
      placeholder: "Items....",
    },
    {
      label: "Category",
      name: "category",
      type: "select",
      placeholder: "Category....",
    },
    {
      label: "Rate",
      name: "rate",
      type: "text",
      placeholder: "Rs.00",
    },
    {
      label: "Qty",
      name: "quantity",
      type: "text",
      placeholder: "",
    },
  ];
  return (
    <div className="flex flex-col px-5 py-3">
      <div className="flex w-full justify-between">
        {/* <div className="tittle">Add Expense</div> */}
        {/* <div className="">
          <Link to={{ pathname: "/Expense" }}>
            <button className="button-orange">Back</button>
          </Link>
        </div> */}
      </div>
      <div className="py-5">
        <ExpenseForm
          formDetails={formDetails}
          addDetails={addDetails}
          optionItems={optionItems}
        />
      </div>
    </div>
  );
};
export default Purchase;
